"use strict";

import React from "react";

const ReturnPolicy = (props) => {
    return (
        <>
            <h3>Return Policy</h3>
            <p>
                We will happily provide a refund, replacement, or credit adjustment for most returned merchandise that
                is returned un-opened and in resaleable condition for up to six months after purchase.
            </p>
            <p>
                Your refund will appear on your original form of payment within 5-10 business days of receiving your
                return.
            </p>
            <p>
                Returned items should be sent to the following address:
                <em> 9655 Penn Avenue South, Minneapolis, MN&nbsp; 55431 </em>
                and should include the original order number or a copy of the order for reference.
            </p>
            <h4>Please Note</h4>
            <ul>
                <li>
                    Tax Forms, envelopes and software purchased for the 2025 filing season must be returned by December
                    31, 2025 to receive a refund
                </li>
                <li>Refunds are not accepted at any time for a downloadable version of any tax preparation software</li>
                <li>
                    Tax Forms, envelopes and software purchased on or after January 1, 2026 are not accepted for return
                </li>
                <li>Imprinted items may only be returned if due to our printing error</li>
                <li>
                    All slip sheet folders and envelopes with window alignment issues are required to provide a PDF of
                    the slip sheet prior to returning product
                </li>
                <li>No refunds are given for shipping charges or remitted sales taxes</li>
            </ul>
        </>
    );
};

export default ReturnPolicy;
